// lib
import React, { createRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Map, fromJS } from 'immutable'

// import { encodeText, decodeText } from '@aytm/app/stats/lib/helpers'

// components
import { Dropdown } from 'primereact/dropdown'

// import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'

// styles
import style from '@aytm/app/stats/page/sidebar/weighting/styles/WeightingItem.module.scss'

const setInputFilter = (textbox, inputFilter) => {
  const events = ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop']
  events.forEach(event => {
    textbox.addEventListener(event, () => {
      if (inputFilter(textbox.value)) {
        textbox.oldValue = textbox.value
        textbox.oldSelectionStart = textbox.selectionStart
        textbox.oldSelectionEnd = textbox.selectionEnd
      } else if (textbox.oldValue) {
        textbox.value = textbox.oldValue
        textbox.setSelectionRange(textbox.oldSelectionStart, textbox.oldSelectionEnd)
      } else {
        textbox.value = ''
      }
    })
  })
}

// <Component>
const WeightingItem = ({ index, model, options, surveyData, disabled, onUpdate, onRemove }) => {
  const [inputsRefs, setInputsRefs] = useState([])

  const onSelect = value => {
    const trait = surveyData.traits.find(t => value == t.id)
    if (trait != undefined) {
      const item = {
        key: String(value),
        items: trait.values.map(v => {
          return {
            key: v.id,
            text: v.name.en || v.name,
            target: 0,
            actual: 0,
            final: 0
          }
        })
      }
      onUpdate(index, fromJS(item))
      return
    }
    const question = surveyData.questions.find(q => q.position == value)
    if (question != undefined) {
      const item = {
        key: String(value),
        items: question.answerVariants
          .filter(v => v !== null)
          .map(v => {
            return {
              key: v.position,
              text: v.text,
              target: 0,
              actual: 0,
              final: 0
            }
          })
      }
      onUpdate(index, fromJS(item))
      return
    }
    if (surveyData.virtual[value] != undefined) {
      const item = {
        key: String(value),
        items: surveyData.virtual[value].answerVariants.map(v => {
          return {
            key: v.position,
            text: v.text,
            target: 0,
            actual: 0,
            final: 0
          }
        })
      }
      onUpdate(index, fromJS(item))
    }
  }

  useEffect(() => {
    setInputsRefs(ref =>
      Array(model.get('items').size)
        .fill()
        .map((_, i) => ref[i] || createRef())
    )
  }, [model])
  useEffect(() => {
    inputsRefs.forEach(ref => setInputFilter(ref.current.refInput, value => /^\d*\.?\d*$/.test(value)))
  }, [inputsRefs])

  // const renderItems = () => {
  //   return model.get('items').map((item, index) => (
  //     <div key={`item-${item.get('key')}`} className={`${style.row} p-fluid`}>
  //       <div className={`${style.item} p-field p-col-12`}>
  //         <div className={style['item-text']}>{item.get('text')}</div>
  //         <div className={style['item-target']}>
  //           <TextField
  //             ref={inputsRefs[index]}
  //             theme="small"
  //             width="60px"
  //             debounce={100}
  //             value={String(item.get('target'))}
  //           />
  //           <div className={style['item-target-affix']}>%</div>
  //         </div>
  //         <div className={style['item-actual']}>{item.get('actual')}%</div>
  //         <div className={style['item-final']}>{item.get('final')}%</div>
  //       </div>
  //     </div>
  //   ))
  // }

  return (
    <div className={style.component}>
      <div className={`${style.row} p-fluid`}>
        <div className="p-field p-col-12">
          <span className={style.delete} onClick={() => onRemove(index)}>
            <i className="icon-aytmfd-delete" />
          </span>
          <Dropdown
            placeholder="Choose dimension"
            value={model.get('key')}
            options={options}
            optionValue="value"
            optionLabel="text"
            fixedDropdownDir="bottom"
            onChange={disabled ? null : event => onSelect(event.value)}
          />
        </div>
      </div>
    </div>
  )
}

WeightingItem.propTypes = {
  index: PropTypes.number.isRequired,
  model: PropTypes.instanceOf(Map),
  options: PropTypes.array,
  surveyData: PropTypes.object,
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func,
  onRemove: PropTypes.func
}

WeightingItem.displayName = 'WeightingItem'

export default WeightingItem
